import { isBranchConstrained } from "../../../../auth/sessionAccess.ts";
import React, { useEffect, useState } from "react";
import { useAppSettings } from "../../../../hooks/useAppSettings.tsx";
import Layout from "../../../Layout.tsx";
import Title from "../../../Title.tsx";
import { Panel, PanelHeader } from "../../../panel/panel.jsx";
import { readSchedulesOrganigram } from "../../../../services/branchSchedule.service.ts";
import S3Service from "../../../../services/s3.service.ts";
import ModalContainer from "../../../ModalContainer.tsx";
import { NodeDatum } from "../../../../interfaces/others/INodeDatum.ts";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/index.ts";
import { getAntiguedad } from "../../../../utils/constanst.js";
import { readBranches } from "../../../../services/branch.service.ts";

const styles: { [key: string]: React.CSSProperties } = {
  branchSelect: {
    minWidth: 180,
    padding: "6px 10px",
    borderRadius: 12,
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    fontSize: 12,
    color: "#111827",
    fontWeight: 600,
    outline: "none",
  },
  scheduleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 12px",
    borderRadius: 12,
    border: "1px solid #1d4ed8",
    background:
      "linear-gradient(135deg, rgba(37,99,235,1) 0%, rgba(59,130,246,1) 100%)",
    color: "#ffffff",
    fontSize: 12,
    fontWeight: 500,
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(37, 99, 235, 0.35)",
    whiteSpace: "nowrap",
  },
  scheduleButtonIcon: {
    fontSize: 13,
  },
  scheduleButtonText: {
    fontSize: 12,
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: 12,
    marginTop: 6,
    marginBottom: 24,
    padding: "0 20px",
  },
  statsCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "12px 16px",
    borderRadius: 12,
    background: "#f9fafb",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
    border: "1px solid #e5e7eb",
  },
  statsIconWrapper: {
    width: 28,
    height: 28,
    borderRadius: 999,
    backgroundColor: "rgba(255,255,255,0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  statsIcon: {
    fontSize: 14,
    color: "#ffffff",
  },
  statsContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  statsLabel: {
    fontSize: 10,
    color: "#e5e7eb",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  statsValue: {
    fontSize: 20,
    fontWeight: 700,
    color: "#ffffff",
  },
  statsCardPresent: {
    background: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)",
    borderColor: "rgba(22, 163, 74, 0.5)",
  },
  statsCardLate: {
    background: "linear-gradient(135deg, #facc15 0%, #f97316 100%)",
    borderColor: "rgba(245, 158, 11, 0.6)",
  },
  statsCardAbsent: {
    background: "linear-gradient(135deg, #f97373 0%, #ef4444 100%)",
    borderColor: "rgba(239, 68, 68, 0.6)",
  },
  shiftColumn: {
    padding: "0 10px",
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  shiftHeader: {
    fontSize: 14,
    fontWeight: 700,
    color: "#111827",
    textAlign: "center",
    textTransform: "uppercase",
    marginBottom: 15,
    paddingBottom: 8,
    borderBottom: "2px solid #e5e7eb",
    letterSpacing: "1px",
  },
  card: {
    width: "100%",
    maxWidth: "140px",
    padding: "8px",
    borderRadius: "0",
    border: "none",
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginBottom: "8px",
    position: "relative",
  },
  avatarContainer: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    overflow: "hidden",
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 4,
  },
  avatarImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
    borderWidth: 3,
    borderStyle: "solid",
  },
  cardName: {
    fontSize: 13,
    fontWeight: 700,
    color: "#111827",
    textAlign: "center",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cardPosition: {
    fontSize: 11,
    color: "#4b5563",
    textAlign: "center",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};

const BranchOrganigrama = () => {
  useAppSettings();
  const { id: ipParams } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  let initialId = isBranchConstrained(user) ? user.branchId : ipParams;
  const [selectedBranchId, setSelectedBranchId] = useState<any>(initialId);
  const [branches, setBranches] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [orgChart, setOrgChart] = useState<NodeDatum | null>(null);
  const [profileImages, setProfileImages] = useState<{ [key: string]: string }>(
    {},
  );
  const [replacementNodes, setReplacementNodes] = useState<{
    [key: string]: boolean;
  }>({});
  const [selectedNode, setSelectedNode] = useState<NodeDatum | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const data = await readBranches();
        setBranches(data || []);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    loadBranches();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedBranchId) return;
      setLoading(true);
      try {
        const data = await readSchedulesOrganigram(Number(selectedBranchId));
        setOrgChart(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedBranchId]);

  const leaderNode = React.useMemo(() => {
    if (!orgChart) return null;
    let found: NodeDatum | null = null;
    const find = (node: NodeDatum) => {
      if (found) return;
      if (node.position && node.position.includes("Líder de Sucursal SUC")) {
        found = node;
        return;
      }
      node.children?.forEach(find);
    };
    find(orgChart);
    return found;
  }, [orgChart]);

  const attendanceStats = React.useMemo(() => {
    if (!orgChart) return { present: 0, late: 0, absent: 0 };

    const allNodes: NodeDatum[] = [];
    const collect = (node: NodeDatum) => {
      allNodes.push(node);
      node.children?.forEach((child) => collect(child));
    };
    collect(orgChart);

    let present = 0,
      late = 0,
      absent = 0;
    allNodes.forEach((node) => {
      const status = (node.assistanceCheck?.status || "").toLowerCase();
      if (status === "asistencia") present++;
      else if (status.includes("retardo") || status.includes("tarde")) late++;
      else if (node.startTime) {
        const [h, m] = node.startTime.split(" - ")[0].split(":").map(Number);
        const start = new Date();
        start.setHours(h, m, 0, 0);
        if (new Date() > start && !node.assistanceCheck) absent++;
      }
    });
    return { present, late, absent };
  }, [orgChart]);

  const fetchProfileImage = async (curp: string) => {
    try {
      const profileUrl = await S3Service.getFile("PERFIL_" + curp);
      setProfileImages((prev) => ({ ...prev, [curp]: profileUrl.url }));
    } catch (error) {
      setProfileImages((prev) => ({
        ...prev,
        [curp]:
          "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png",
      }));
    }
  };

  const handleToggleReplacement = (id: number) => {
    setReplacementNodes((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getBorderColor = (node: NodeDatum, useReplacement: boolean) => {
    const activeNode =
      useReplacement && node.replacementOf ? node.replacementOf : node;

    const status = (activeNode.assistanceCheck?.status || "").toLowerCase();
    const checkTimeRaw =
      (activeNode.assistanceCheck as any)?.checkTime ||
      (activeNode.assistanceCheck as any)?.check_time ||
      "";

    const startString = activeNode.startTime?.split(" - ")?.[0] || "";

    const parseTimeToDate = (time: string) => {
      const [h, m] = time.split(":").map(Number);
      const d = new Date();
      d.setHours(h || 0, m || 0, 0, 0);
      return d;
    };

    // Si hay hora de entrada registrada, decidir puntualidad con ella
    if (checkTimeRaw && startString) {
      const startDate = parseTimeToDate(startString);
      const checkDate = parseTimeToDate(checkTimeRaw);
      const diffMinutes = (checkDate.getTime() - startDate.getTime()) / 60000;
      if (diffMinutes > 0) {
        return "#E5BA41"; // retardo
      }
      return "#72BF78"; // asistencia puntual
    }

    // Si el backend marcó el status explícitamente
    if (status === "asistencia") {
      return "#72BF78";
    }

    if (status.includes("retardo") || status.includes("tarde")) {
      return "#E5BA41";
    }

    if (!startString) {
      return "#B7B7B7";
    }

    // Sin checkTime: decidir por hora actual vs hora programada
    const startDate = parseTimeToDate(startString);
    const now = new Date();
    const diffInMinutes = (now.getTime() - startDate.getTime()) / 60000;

    if (diffInMinutes < 0) {
      return "#B7B7B7"; // aún no inicia
    }
    if (diffInMinutes <= 15) {
      return "#E5BA41"; // dentro de ventana de retardo
    }
    return "#FF0000"; // falta
  };

  const renderEmployee = (node: NodeDatum) => {
    if (!node) return null;
    const isReplacementVisible =
      replacementNodes[node.id] && node.replacementOf;
    const curpToFetch = isReplacementVisible
      ? node.replacementOf?.partner?.person?.curp
      : node.curp;

    if (curpToFetch && !profileImages[curpToFetch]) {
      fetchProfileImage(curpToFetch);
    }

    const profileImage =
      curpToFetch && profileImages[curpToFetch]
        ? profileImages[curpToFetch]
        : "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png";

    const borderColor = getBorderColor(node, Boolean(isReplacementVisible));

    return (
      <div
        key={node.id}
        style={styles.card}
        onClick={() => {
          setSelectedNode(node);
          setShowModal(true);
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        {node.replacementOf && (
          <button
            title="Ver/Ocultar reemplazo"
            className="position-absolute bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: 22,
              height: 22,
              top: 0,
              right: 15,
              zIndex: 5,
              border: "2px solid #fff",
              fontSize: "10px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleToggleReplacement(node.id);
            }}
          >
            <i className="fas fa-exchange"></i>
          </button>
        )}

        <div style={styles.avatarContainer}>
          <img
            src={profileImage}
            alt={node.name}
            style={{ ...styles.avatarImage, borderColor, fontSize: 0 }}
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src =
                "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png";
            }}
          />
        </div>

        <div style={styles.cardName} title={node.name}>
          {replacementNodes[node.id]
            ? node.replacementOf?.partner?.person?.firstName
            : node.name}
        </div>
        <div style={styles.cardPosition} title={node.position}>
          {replacementNodes[node.id]
            ? node.replacementOf?.positionName
            : node.position}
        </div>

        {replacementNodes[node.id] && (
          <div
            style={{ fontSize: "9px", letterSpacing: "0.4px" }}
            className="text-danger fw-bold text-uppercase mt-1"
          >
            REEMPLAZADO
          </div>
        )}
      </div>
    );
  };

  const getEmployeesByShift = (shift: string) => {
    if (!orgChart) return [];

    const employees: NodeDatum[] = [];
    const traverse = (node: NodeDatum) => {
      const isLeader =
        node.position && node.position.includes("Líder de Sucursal SUC");
      if (!isLeader && node.shift === shift) employees.push(node);
      node.children?.forEach(traverse);
    };

    traverse(orgChart);

    return employees;
  };

  return (
    <Layout loading={loading}>
      <Title
        baseTitle="Sucursales"
        basePath="/sucursales"
        activeTitle="Organigrama de trabajadores"
        title="Organigrama de trabajadores"
      />
      <div className="card border-0 m-4 rounded">
        <Panel>
          <PanelHeader
            noButton={true}
            className="bg-azul"
            extra={
              <div className="d-flex align-items-center gap-3">
                {!isBranchConstrained(user) && (
                  <select
                    style={styles.branchSelect}
                    value={selectedBranchId ?? ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedBranchId(value ? Number(value) : null);
                    }}
                  >
                    <option value="" disabled>
                      Selecciona sucursal
                    </option>
                    {branches.map((b) => (
                      <option key={b.id} value={b.id}>
                        {b.name}
                      </option>
                    ))}
                  </select>
                )}
                {selectedBranchId && (
                  <button
                    type="button"
                    style={styles.scheduleButton}
                    onClick={() =>
                      navigate(`/sucursales/horario/${selectedBranchId}`)
                    }
                  >
                    <i
                      className="fa-solid fa-calendar-plus"
                      style={styles.scheduleButtonIcon}
                    ></i>
                    <span style={styles.scheduleButtonText}>
                      Programar horario
                    </span>
                  </button>
                )}
              </div>
            }
          >
            Organigrama de trabajadores
          </PanelHeader>

          <div className="py-5 bg-white rounded-bottom">
            {/* Stats Row */}
            <div style={styles.statsRow}>
              <div style={{ ...styles.statsCard, ...styles.statsCardPresent }}>
                <div style={styles.statsIconWrapper}>
                  <i
                    className="fa-solid fa-circle-check"
                    style={styles.statsIcon}
                  ></i>
                </div>
                <div style={styles.statsContent}>
                  <div style={styles.statsValue}>{attendanceStats.present}</div>
                  <div style={styles.statsLabel}>Asistieron</div>
                </div>
              </div>
              <div style={{ ...styles.statsCard, ...styles.statsCardLate }}>
                <div style={styles.statsIconWrapper}>
                  <i className="fa-solid fa-clock" style={styles.statsIcon}></i>
                </div>
                <div style={styles.statsContent}>
                  <div style={styles.statsValue}>{attendanceStats.late}</div>
                  <div style={styles.statsLabel}>Retardos</div>
                </div>
              </div>
              <div style={{ ...styles.statsCard, ...styles.statsCardAbsent }}>
                <div style={styles.statsIconWrapper}>
                  <i
                    className="fa-solid fa-triangle-exclamation"
                    style={styles.statsIcon}
                  ></i>
                </div>
                <div style={styles.statsContent}>
                  <div style={styles.statsValue}>{attendanceStats.absent}</div>
                  <div style={styles.statsLabel}>No llegaron</div>
                </div>
              </div>
            </div>

            {leaderNode && (
              <div className="d-flex justify-content-center mb-5">
                {renderEmployee(leaderNode)}
              </div>
            )}

            <div className="container-fluid px-4">
              <div className="row g-4">
                {["Matutino", "Intermedio", "Vespertino"].map((shift) => {
                  const employeesByShift = getEmployeesByShift(shift);
                  return (
                    <div className="col-md-4" key={shift}>
                      <div style={styles.shiftColumn}>
                        <div style={styles.shiftHeader}>{shift}</div>
                        <div className="d-flex flex-wrap justify-content-center gap-3">
                          {employeesByShift.length > 0 ? (
                            employeesByShift.map(renderEmployee)
                          ) : (
                            <div className="text-muted small py-5 d-flex flex-column align-items-center">
                              <i
                                className="fa-solid fa-user-slash mb-2 opacity-50"
                                style={{ fontSize: "24px" }}
                              ></i>
                              Sin colaboradores
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Panel>
      </div>

      {selectedNode && (
        <ModalContainer
          open={showModal}
          title="Detalles del colaborador"
          closeFn={() => setShowModal(false)}
        >
          <div className="p-3">
            <div className="d-flex align-items-center mb-4">
              <div
                className="me-4 shadow-sm"
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "3px solid #eee",
                }}
              >
                <img
                  src={
                    profileImages[
                      replacementNodes[selectedNode.id]
                        ? selectedNode.replacementOf?.partner?.person?.curp ||
                          ""
                        : selectedNode.curp
                    ] ||
                    "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"
                  }
                  className="w-100 h-100"
                  style={{ objectFit: "cover" }}
                  alt="Profile"
                />
              </div>
              <div>
                <h4 className="mb-1 fw-bold">
                  {replacementNodes[selectedNode.id]
                    ? selectedNode.replacementOf?.partner?.person?.firstName
                    : selectedNode.name}
                </h4>
                <p className="mb-1 text-muted">
                  {replacementNodes[selectedNode.id]
                    ? selectedNode.replacementOf?.positionName
                    : selectedNode.position}
                </p>
                {selectedNode.partnerId && (
                  <a
                    href={`/colaboradores/detalles/${selectedNode.partnerId}`}
                    className="btn btn-sm btn-outline-primary mt-2 rounded-pill px-3"
                  >
                    <i className="fa-solid fa-user me-2"></i> Ver perfil
                    completo
                  </a>
                )}
              </div>
            </div>

            <div className="row g-3">
              <div className="col-6">
                <div className="p-3 border rounded bg-light">
                  <small
                    className="text-muted text-uppercase fw-bold opacity-75"
                    style={{ fontSize: "10px" }}
                  >
                    Estatus Asistencia
                  </small>
                  <div className="fw-bold mt-1">
                    {selectedNode.assistanceCheck?.status || "Sin registro"}
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="p-3 border rounded bg-light">
                  <small
                    className="text-muted text-uppercase fw-bold opacity-75"
                    style={{ fontSize: "10px" }}
                  >
                    Turno
                  </small>
                  <div className="fw-bold mt-1">{selectedNode.shift}</div>
                </div>
              </div>
              <div className="col-12">
                <div className="p-3 border rounded bg-light">
                  <small
                    className="text-muted text-uppercase fw-bold opacity-75"
                    style={{ fontSize: "10px" }}
                  >
                    Horario Programado
                  </small>
                  <div className="fw-bold mt-1">
                    {selectedNode.startTime && selectedNode.endTime
                      ? `${selectedNode.startTime.split(" - ")[0]} - ${
                          selectedNode.endTime.split(" - ").slice(-1)[0]
                        }`
                      : "No disponible"}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="p-3 border rounded bg-light">
                  <small
                    className="text-muted text-uppercase fw-bold opacity-75"
                    style={{ fontSize: "10px" }}
                  >
                    Antigüedad
                  </small>
                  <div className="fw-bold mt-1">
                    {getAntiguedad(selectedNode.candidate?.recruitmentDate) ||
                      "No disponible"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalContainer>
      )}
    </Layout>
  );
};

export default BranchOrganigrama;
